export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6710.00141f4c.jpg";